import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "content--center text-white overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-gray-info"
}

import { computed } from 'vue';

export interface Props {
  name: string;
  description?: string;
  image?: string;
  spaced?: string;
  sized?: 'large';
}


export default /*#__PURE__*/_defineComponent({
  props: {
    name: null,
    description: { default: '' },
    image: { default: '' },
    spaced: { default: 'space-x-2' },
    sized: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { name: string, description: string, image: string, spaced: string, sized: 'large' }



const isLarge = computed(() => props.sized === 'large');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center", __props.spaced])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.image)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([_unref(isLarge) ? 'w-10' : 'w-8', "bg-no-repeat bg-cover bg-center"]),
            style: _normalizeStyle({
          'aspect-ratio': '1/1',
          'background-image': `url(${__props.image})`,
        })
          }, null, 6))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["font-medium", { 'text-xl': _unref(isLarge) }])
      }, _toDisplayString(__props.name), 3),
      (__props.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.description), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})